import React, { useContext } from 'react';
import { ConsolidatedHeaderComponent } from '../../components/Metrics/ConsolidatedHeader/ConsolidatedHeaderComponent';
import AdvancedDailyEngagedUsersContext from '../../../../contexts/Billing/AdvancedDailyEngagedUsersContext';

const AdvancedDailyEngagedUserTitle: React.FC = () => {
  const { content, dateToSearch, currentMonth } = useContext(
    AdvancedDailyEngagedUsersContext
  );

  return (
    <ConsolidatedHeaderComponent
      infoHeader={content.compiledInformation.plan}
      dateToSearch={dateToSearch}
      currentMonth={currentMonth}
      showConsolidatedBorder={false}
      middleInfoContent={content.compiledInformation.disclaimer}
    />
  );
};

export default AdvancedDailyEngagedUserTitle;